var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-col",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingAssignedApplications,
              expression: "loadingAssignedApplications"
            }
          ],
          attrs: { xs: 24, sm: 10, md: 9, lg: 7, xl: 5 }
        },
        [
          _c("el-card", { staticClass: "newApplicationsMenu" }, [
            _c("div", { staticClass: "text item" }, [
              _c(
                "li",
                {
                  key: 0,
                  staticClass: "list-group-item",
                  on: { click: _vm.toggleNewApplications }
                },
                [
                  _c("el-card", [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            _vm.loadAppsOnAssingDialog(true, _vm.dateRange)
                          }
                        }
                      },
                      [_c("span", [_vm._v("Ανάληψη-Αποδέσμευση")])]
                    )
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("applications-lane", {
            attrs: {
              assignedApplications: _vm.assignedApplications,
              assignedApps: _vm.assignedApps
            },
            on: { addUniversity: _vm.addUniversityEvent }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "el-fade-in-linear" } },
        [
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingWorkingApplication,
                  expression: "loadingWorkingApplication"
                }
              ],
              attrs: { xs: 24, sm: 14, md: 15, lg: 17, xl: 16 }
            },
            [
              _c(
                "div",
                { staticClass: "grid-content bg-purple" },
                [
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "Ανάληψη-Αποδέσμευση",
                        visible: _vm.dialogView,
                        width: "90%"
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogView = $event
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        [
                          _c(
                            "el-form",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "Επιλέξτε διάστημα υποβολής" }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "daterange",
                                      "range-separator": "To",
                                      "start-placeholder": "Start date",
                                      format: "dd/MM/yyyy",
                                      "value-format": "dd-MM-yyyy",
                                      "end-placeholder": "End date"
                                    },
                                    on: { change: _vm.periodSelected },
                                    model: {
                                      value: _vm.dateRange,
                                      callback: function($$v) {
                                        _vm.dateRange = $$v
                                      },
                                      expression: "dateRange"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                "margin-top": "5px"
                              }
                            },
                            [
                              _c("el-transfer", {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.loadingAllApplications,
                                    expression: "loadingAllApplications"
                                  }
                                ],
                                staticStyle: {
                                  "margin-top": "5px",
                                  "text-align": "left",
                                  display: "inline-block"
                                },
                                attrs: {
                                  filterable: "",
                                  titles: ["Νέες Αιτήσεις", "Οι Αιτήσεις μου"],
                                  "button-texts": ["Αποδέσμευση", "Ανάληψη"],
                                  format: {
                                    noChecked: "${total}",
                                    hasChecked: "${checked}/${total}"
                                  },
                                  data: _vm.allApplications
                                },
                                on: {
                                  change: _vm.newAssignedApplications,
                                  "left-check-change": _vm.appsToAssignChanged,
                                  "right-check-change": _vm.appsToReleaseChanged
                                },
                                model: {
                                  value: _vm.myApplications,
                                  callback: function($$v) {
                                    _vm.myApplications = $$v
                                  },
                                  expression: "myApplications"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-error",
                                    plain: "",
                                    round: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      ;(_vm.dialogView = false),
                                        _vm.toggleNewApplications
                                    }
                                  }
                                },
                                [_vm._v("Κλείσιμο\n              ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    icon: "el-icon-refresh",
                                    plain: "",
                                    round: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.loadAppsOnAssingDialog(
                                        false,
                                        _vm.dateRange
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Ανανέωση\n              ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showWorkingApplication
                    ? _c("el-card", { staticClass: "box-card bg-purple" }, [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix",
                            attrs: { slot: "header" },
                            slot: "header"
                          },
                          [_c("user-app-info")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text item" },
                          [
                            _c(
                              "el-tabs",
                              {
                                attrs: {
                                  stretch: true,
                                  "tab-position": _vm.tabPosition
                                },
                                on: { "tab-click": _vm.handleClick },
                                model: {
                                  value: _vm.activeName,
                                  callback: function($$v) {
                                    _vm.activeName = $$v
                                  },
                                  expression: "activeName"
                                }
                              },
                              [
                                _c(
                                  "el-tab-pane",
                                  {
                                    attrs: {
                                      label: "Προσωπικά Στοιχεία",
                                      name: "first"
                                    }
                                  },
                                  [
                                    _c("personal-details", {
                                      attrs: {
                                        personalDetails:
                                          _vm.workingApplication.personalDetails
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isReappraisal && !_vm.isPostExam
                                  ? _c(
                                      "el-tab-pane",
                                      {
                                        attrs: {
                                          label: "Τίτλος Σπουδών",
                                          name: "second"
                                        }
                                      },
                                      [
                                        _c("titles", {
                                          attrs: {
                                            application: _vm.workingApplication
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isReappraisal &&
                                !_vm.isPostExam &&
                                _vm.workingApplication.degreeType ===
                                  "bachelor" &&
                                _vm.workingApplication.consideration === true
                                  ? _c(
                                      "el-tab-pane",
                                      {
                                        attrs: {
                                          label: "Συνυποβολή Τίτλου",
                                          name: "third"
                                        }
                                      },
                                      [
                                        _c("title-consideration", {
                                          attrs: {
                                            application: _vm.workingApplication
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-tab-pane",
                                  {
                                    attrs: {
                                      label: "Επισυναπτόμενα",
                                      name: "fourth"
                                    }
                                  },
                                  [
                                    _c("attached-documents", {
                                      attrs: {
                                        recommendations: _vm.recommendations,
                                        userComment:
                                          _vm.workingApplication.userComment,
                                        attachedDocumentsTable:
                                          _vm.attachedDocumentsTable,
                                        appId: _vm.workingApplication.id,
                                        role: _vm.role,
                                        generalCommentProp:
                                          _vm.generalCommentInDocs,
                                        generalCommentWorking:
                                          _vm.generalCommentWorking,
                                        neededDocuments:
                                          _vm.workingApplication
                                            .neededDocuments,
                                        isPostExam: _vm.isPostExam
                                      },
                                      on: {
                                        changedAttachedDocs:
                                          _vm.changedAttachedDocsEvent,
                                        changedGeneralComment:
                                          _vm.changedGeneralCommentEvent
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-tab-pane",
                                  {
                                    attrs: {
                                      label: "Ιστορικό",
                                      name: "fifth",
                                      lazy: true
                                    }
                                  },
                                  [
                                    _c("history-line", {
                                      attrs: { applicationHistory: _vm.history }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-tab-pane",
                                  {
                                    attrs: {
                                      label: "Αποτέλεσμα Επεξεργασίας",
                                      name: "sixth"
                                    }
                                  },
                                  [
                                    _c("prechecker-judgment", {
                                      attrs: {
                                        specialProponents:
                                          _vm.specialProponents,
                                        recommendations: _vm.recommendations,
                                        judgementDocs: _vm.judgementDocs,
                                        attachedDocumentsTable:
                                          _vm.attachedDocumentsTable,
                                        generalCommentWorking:
                                          _vm.generalCommentWorking,
                                        generalComment: _vm.generalComment,
                                        isReappraisal: _vm.isReappraisal,
                                        isPostExam: _vm.isPostExam,
                                        isSecondReappraisal:
                                          _vm.isSecondReappraisal
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isReappraisal || _vm.isPostExam
                                  ? _c(
                                      "el-tab-pane",
                                      {
                                        attrs: {
                                          label: "Σχετική αίτηση",
                                          name: "seventh"
                                        }
                                      },
                                      [
                                        _c("relevant-app", {
                                          attrs: {
                                            relevantApp:
                                              _vm.workingApplication
                                                .relevantApplication
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isSecondReappraisal
                                  ? _c(
                                      "el-tab-pane",
                                      {
                                        attrs: {
                                          label: "Αρχική επανεξέταση",
                                          name: "eighth"
                                        }
                                      },
                                      [
                                        _c("first-reappraisal", {
                                          attrs: {
                                            relevantReappraisalApplication:
                                              _vm.workingApplication
                                                .relevantReappraisalApplication,
                                            relevantReappraisalAppl:
                                              _vm.workingApplication
                                                .relevantReappraisalAppl
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("application-search", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchVisible,
                    expression: "searchVisible"
                  }
                ]
              }),
              _vm._v(" "),
              _c("search-uni", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchUniVisible,
                    expression: "searchUniVisible"
                  }
                ]
              }),
              _vm._v(" "),
              _vm.addUniversity
                ? _c("manage-db", {
                    attrs: { addUniversity: _vm.addUniversity }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30c5aac2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c5aac2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prechecker.vue
// module id = null
// module chunks = 